/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Su_HInputs */

const en_funnel_su_h = /** @type {(inputs: Funnel_Su_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your setup is ready`)
};

const es_funnel_su_h = /** @type {(inputs: Funnel_Su_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu configuración está lista`)
};

/**
* | output |
* | --- |
* | "Your setup is ready" |
*
* @param {Funnel_Su_HInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_su_h = /** @type {((inputs?: Funnel_Su_HInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Su_HInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_su_h(inputs)
	return en_funnel_su_h(inputs)
});